import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { PrintingProfileEntity } from "../../types/PrintingProfileEntity";
import { PrintingProfileDtoToEntity } from "../mappers/PrintingProfileDtoToEntity";
import { PrintingProfileEntityToDto } from "../mappers/PrintingProfileEntityToDto";

const PrintingProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        PrintingProfileLoad: builder.query<PrintingProfileEntity, FormQuery>({
            providesTags: [ResourceName.PRINTING_PROFILES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRINTING_PROFILES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return PrintingProfileDtoToEntity(response);
            },
        }),
        PrintingProfileSave: builder.mutation<PrintingProfileEntity, FormMutation<PrintingProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRINTING_PROFILES}`;
                const method = "POST";

                const body = PrintingProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.PRINTING_PROFILES],
        }),
        PrintingProfileUpdate: builder.mutation<PrintingProfileEntity, FormMutation<PrintingProfileEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRINTING_PROFILES}/${mutation.data.id}`;
                const method = "PUT";

                const body = PrintingProfileEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.PRINTING_PROFILES],
        }),
    }),
});

export const { usePrintingProfileLoadQuery, usePrintingProfileSaveMutation, usePrintingProfileUpdateMutation } = PrintingProfileApi;
